import React, { Component } from "react";
import "./css/ChampionDescription.css";

export default class ChampionDescription extends Component {
  render() {
    return (
      <div
        className="flex championDescription"
        style={{
          position: "absolute",
          height: "60%"
        }}
      >
        <img
          draggable={false}
          src={this.props.image}
          alt="champion-portrait"
          style={{ height: "100%", width: "253px" }}
        />
        <div>
          {this.props.title ? <h3>{this.props.title}</h3> : null}
          <p style={!this.props.title ? { marginTop: "10px" } : null}>
            {this.props.text}
          </p>
        </div>
      </div>
    );
  }
}
